import createDecorator from './createDecorator'

import DecoratorComponent from './Component'

import decoratePlugins from './helper/decoratePlugins'

const createPluginDecorator = settings =>
    createDecorator({
        DecoratorComponent,
        decoratePlugins,
        ...settings,
    })

const decorator = createPluginDecorator()
export default decorator

export { createPluginDecorator, DecoratorComponent }
